export const TX_CATEGORY_TREE = {
  'Dining & Drinks': ['Convience Store', 'Bars', 'Fast Food', 'Restaurants', 'Liquor', 'Coffee Shops'],
  'Shopping': ['Electronics', 'Clothing', 'Books'],
  'Groceries': [],
  'Auto & Transport': ['Gas & Fuel', 'Parking', 'Service & Parts', 'Car Insurance', 'Tolls', 'Public Transportation', 'Rideshare', 'Car Payment'],
  'Home': ['Mortgage', 'Home Improvement', 'Home Services', 'Home Supplies', 'Furnishings', 'HOA Dues', 'Property Tax', 'Home Insurance', 'Rent'],
  'Utilities': ['Gas & Electric', 'Internet & Cable', 'Water', 'Phone'],
  'Travel': ['Airfare', 'Rental Car & Taxi', 'Hotel', 'Vacation'],
  'Entertainment': ['Gambling', 'Wedding'],
  'Health': ['Dentist', 'Doctor', 'Pharmacy', 'Eyecare'],
  'Fitness': ['Gym'],
  'Personal Income': ['Paycheck', 'Interest Earned', 'Rental Income'],
  'Fees & Charges': ['Finance Charge', 'Service Fee', 'Late Fee', 'ATM Fee'],
  'Business Services': ['Legal'],
  'Education': ['Tuition'],
  'Gifts': [],
  'Cash & ATM': [],
  'Personal Care': [],
  'Charity & Donations': [],
  'Financial': [],
  'Transfer': [],
  'Credit Card Payment': [],
  'NA': [],
  'Uncategorized': [],
  'Other': [],
};

// Flat list with parent:child format
export const TX_CATEGORIES = [];
Object.entries(TX_CATEGORY_TREE).forEach(([parent, children]) => {
  TX_CATEGORIES.push(parent);
  children.forEach((child) => TX_CATEGORIES.push(`${parent}:${child}`));
});

export function CategoryOptions() {
  return Object.entries(TX_CATEGORY_TREE).map(([parent, children]) => {
    if (children.length === 0) {
      return <option key={parent} value={parent}>{parent}</option>;
    }
    return (
      <optgroup key={parent} label={parent}>
        <option value={parent}>{parent} (general)</option>
        {children.map((child) => (
          <option key={`${parent}:${child}`} value={`${parent}:${child}`}>{child}</option>
        ))}
      </optgroup>
    );
  });
}

export function getCategoryLabel(cat) {
  if (!cat) return 'Uncategorized';
  if (cat.includes(':')) return cat.split(':')[1];
  return cat;
}

export function getCategoryParent(cat) {
  if (!cat) return '';
  if (cat.includes(':')) return cat.split(':')[0];
  return cat;
}
